// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHeader_root_VCkUQ {
  margin-top: 0.4em;
  margin-bottom: 0.938em;
  font-family: GothamRounded-Book;
  color: var(--timetable-text-color);
  break-after: avoid;
}

.tableHeader_strong_jNXz6 {
  font-family: GothamXNarrow-Medium;
}

.tableHeader_title_Ck7uG {
  padding: 0.313em 0.45em;
  font-family: GothamXNarrow-Book;
}

.tableHeader_subtitle_lmtq4 {
  display: flex;
  padding: 0 0.625em 0 0.65em;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.tableHeader_subtitle_lmtq4 > *:first-child {
  min-width: 4.2em;
}

.tableHeader_a3Title_y5rt7 {
  font-size: 0.8em;
}

.tableHeader_italics_HIxar {
  font-style: italic;
}

.tableHeader_inline_BuJ7M {
  display: inline;
}

.tableHeader_compactTitle_xs3Ih {
  font-size: 0.8em;
}

.tableHeader_compactSubtitle_JAcsl {
  font-size: 0.5em;
}

.tableHeader_compactRoot_Xrpb8 {
  margin: 0.5em 0;
}

.tableHeader_compactPadding_OdtQi {
  padding-top: 0.15em;
}
`, "",{"version":3,"sources":["webpack://./src/components/timetable/tableHeader.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".root {\n  margin-top: 0.4em;\n  margin-bottom: 0.938em;\n  font-family: GothamRounded-Book;\n  color: var(--timetable-text-color);\n  break-after: avoid;\n}\n\n.strong {\n  font-family: GothamXNarrow-Medium;\n}\n\n.title {\n  padding: 0.313em 0.45em;\n  font-family: GothamXNarrow-Book;\n}\n\n.subtitle {\n  display: flex;\n  padding: 0 0.625em 0 0.65em;\n  font-size: 12px;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n}\n\n.subtitle > *:first-child {\n  min-width: 4.2em;\n}\n\n.a3Title {\n  font-size: 0.8em;\n}\n\n.italics {\n  font-style: italic;\n}\n\n.inline {\n  display: inline;\n}\n\n.compactTitle {\n  font-size: 0.8em;\n}\n\n.compactSubtitle {\n  font-size: 0.5em;\n}\n\n.compactRoot {\n  margin: 0.5em 0;\n}\n\n.compactPadding {\n  padding-top: 0.15em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tableHeader_root_VCkUQ`,
	"strong": `tableHeader_strong_jNXz6`,
	"title": `tableHeader_title_Ck7uG`,
	"subtitle": `tableHeader_subtitle_lmtq4`,
	"a3Title": `tableHeader_a3Title_y5rt7`,
	"italics": `tableHeader_italics_HIxar`,
	"inline": `tableHeader_inline_BuJ7M`,
	"compactTitle": `tableHeader_compactTitle_xs3Ih`,
	"compactSubtitle": `tableHeader_compactSubtitle_JAcsl`,
	"compactRoot": `tableHeader_compactRoot_Xrpb8`,
	"compactPadding": `tableHeader_compactPadding_OdtQi`
};
module.exports = ___CSS_LOADER_EXPORT___;
